export function setDeepValue(obj, path, value) {
  const keys = path.split('.');
  let current = obj;

  keys.forEach((key, index) => {
    // Se for a última chave, define o valor
    if (index === keys.length - 1) {
      current[key] = value;
    } else {
      // Se não existir o nível atual, cria como objeto
      if (!current[key] || typeof current[key] !== 'object') {
        current[key] = {};
      }
      current = current[key];
    }
  });

  return obj;
}
